export const authRu = {
  auth: {
    login: 'Войти',
    logout: 'Выйти',
    register: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    password_confirm: 'Подтвердите пароль',
    forgot_password: 'Забыли пароль?',
    reset_password: 'Сбросить пароль',
    change_password: 'Изменить пароль',
    remember_me: 'Запомнить меня',
    login_success: 'Успешный вход',
    logout_success: 'Успешный выход',
    register_success: 'Регистрация успешна. Пожалуйста, проверьте свою электронную почту для подтверждения учётной записи.',
    verify_email_required: 'Вам нужно подтвердить свой email перед продолжением.',
    invalid_credentials: 'Неверный email или пароль',
    already_have_account: 'Уже есть учётная запись?',
    dont_have_account: 'Нет учётной записи?',
    sign_in: 'Войти',
    sign_up: 'Зарегистрироваться',
    sign_in_to_account: 'Войдите в свою учётную запись',
    create_account: 'Создать новую учётную запись',
    current_password: 'Текущий пароль',
    new_password: 'Новый пароль',
    new_password_confirm: 'Подтвердите новый пароль',
    password_changed: 'Пароль успешно изменён',
    reset_link_sent: 'Ссылка для сброса пароля отправлена на ваш email',
    send_reset_link: 'Отправить ссылку',
    back_to_login: 'Вернуться к входу',
    reset_token: 'Токен сброса',
    reset_code: 'Код сброса',
    email_placeholder: 'Ваш email',
    password_requirements: 'Пароль должен быть не менее 8 символов',
    token_placeholder: 'Введите токен из email',
    enter_new_password: 'Введите новый пароль',
    login_with_google: 'Продолжить с Google',
    links: {
      or_create_account: 'Или создайте новую учётную запись',
      create_new_account: 'Создать новую учётную запись',
      or_sign_in: 'Уже есть учётная запись?',
      sign_in_existing: 'Войти в существующую учётную запись',
    },
    official_form: {
      title: 'Войти',
      description: 'Введите email и пароль для доступа к учётной записи',
      forgot_password_link: 'Забыли пароль?',
      logging_in: 'Вход...',
      login_with_google: 'Продолжить с Google',
      no_account: 'Нет учётной записи?',
      sign_up_link: 'Зарегистрироваться',
    },
    form: {
      name: 'Полное имя',
      name_placeholder: 'Введите ваше полное имя',
      email_placeholder: 'Введите ваш email',
      password_placeholder: 'Введите ваш пароль',
      password_confirm_placeholder: 'Подтвердите ваш пароль',
      current_password_placeholder: 'Введите текущий пароль',
      new_password_placeholder: 'Введите новый пароль',
      new_password_confirm_placeholder: 'Подтвердите новый пароль',
      submit_login: 'Войти',
      submit_register: 'Создать учётную запись',
      submit_reset: 'Отправить ссылку сброса',
      submit_reset_password: 'Сбросить пароль',
      submit_change_password: 'Изменить пароль',
    },
    forgot_password_page: {
      title: 'Забыли пароль?',
      subtitle: 'Введите ваш адрес email, и мы отправим вам ссылку для сброса пароля.',
      back_to_login: 'Вернуться к входу',
    },
    reset_password_page: {
      title: 'Установить новый пароль',
      subtitle: 'Введите новый пароль ниже',
      back_to_login: 'Вернуться к входу',
    },
    accept_invite_page: {
      title: 'Настройте свой аккаунт',
      subtitle: 'Установите пароль ниже, чтобы активировать аккаунт.',
      submit_button: 'Активировать аккаунт',
      success: 'Ваш аккаунт активирован. Перенаправление на страницу входа...',
      invalid_or_expired: 'Эта ссылка-приглашение недействительна или истекла. Попросите пригласившего вас отправить новую.',
      back_to_login: 'Вернуться к входу',
    },
    change_password_page: {
      title: 'Изменить пароль',
      subtitle: 'Обновите пароль вашей учётной записи',
    },
    two_factor: {
      title: 'Двухфакторная аутентификация',
      subtitle: 'Добавьте дополнительный уровень безопасности к вашей учётной записи',
      verification_success: 'Верификация успешна',
      verify_button: 'Проверить',
      no_methods_configured: 'Методы 2FA не настроены',
      setup: {
        title: 'Настройка двухфакторной аутентификации',
      },
      verify: {
        title: 'Двухфакторная аутентификация',
      },
      totp: {
        title: 'Приложение-аутентификатор (TOTP)',
        tab_label: 'TOTP',
        description: 'Используйте приложение-аутентификатор, такое как Google Authenticator или Authy',
        setup: 'Настроить приложение-аутентификатор',
        cancel: 'Отмена',
        disable: 'Отключить TOTP',
        disable_confirm: 'Вы уверены, что хотите отключить TOTP аутентификацию?',
        disable_success: 'TOTP аутентификация отключена',
        enabled: 'TOTP аутентификация включена',
        enabled_description: 'Ваше приложение-аутентификатор настроено и активно',
        disabled: 'TOTP отключено',
        scan_qr_code: 'Сканировать QR-код',
        scan_qr_code_description: 'Отсканируйте этот QR-код с помощью вашего приложения-аутентификатора',
        manual_entry: 'Или введите код вручную:',
        copy_secret: 'Копировать секрет',
        secret_copied: 'Секрет скопирован в буфер обмена',
        scan_instructions: 'Отсканируйте QR-код с помощью вашего приложения-аутентификатора (Google Authenticator, Authy и т.д.)',
        scan_step_title: 'Шаг 1: Сканировать QR-код',
        scan_step_description: 'Используйте ваше приложение-аутентификатор для сканирования QR-кода ниже',
        continue_to_verify: 'Перейти к верификации',
        verify_step_title: 'Шаг 2: Проверить код',
        verify_step_description: 'Введите 6-значный код из вашего приложения-аутентификатора',
        code_label: '6-значный код',
        code_placeholder: '000000',
        verify_button: 'Проверить и включить',
        setup_complete: 'Настройка TOTP завершена',
        setup_success: 'TOTP аутентификация успешно включена',
        backup_codes: 'Резервные коды',
        backup_codes_description: 'Сохраните эти резервные коды в безопасном месте. Вы можете использовать их для доступа к учётной записи, если потеряете устройство.',
        backup_codes_warning: 'Каждый резервный код можно использовать только один раз. Храните их безопасно.',
        invalid_code: 'Неверный код. Пожалуйста, попробуйте снова.',
        enter_code_help: 'Введите 6-значный код из вашего приложения-аутентификатора',
      },
      webauthn: {
        title: 'Ключи доступа',
        tab_label: 'Ключи доступа',
        description: 'Используйте биометрическую аутентификацию или ключи безопасности',
        register: 'Зарегистрировать ключ доступа',
        register_title: 'Добавить новый ключ доступа',
        register_description: 'Зарегистрируйте новый ключ доступа, используя биометрическую аутентификацию вашего устройства или ключ безопасности',
        register_success: 'Ключ доступа успешно зарегистрирован',
        verify: 'Использовать ключ доступа',
        verify_instruction: 'Нажмите кнопку ниже для аутентификации с помощью ключа доступа',
        passkey_name: 'Название ключа доступа',
        passkey_name_placeholder: 'например, iPhone, Ноутбук, YubiKey',
        passkey_name_help: 'Дайте вашему ключу доступа запоминающееся название для последующей идентификации',
        no_passkeys: 'Нет зарегистрированных ключей доступа',
        registered_passkeys: 'Зарегистрированные ключи доступа',
        passkeys_description: 'Управляйте вашими зарегистрированными ключами доступа',
        last_used: 'Последнее использование',
        created: 'Создан',
        name: 'Название',
        delete: 'Удалить',
        delete_confirm: 'Вы уверены, что хотите удалить этот ключ доступа?',
        delete_success: 'Ключ доступа успешно удалён',
        add_passkey: 'Добавить новый ключ доступа',
        user_cancelled: 'Аутентификация отменена',
        not_supported: 'Ключи доступа не поддерживаются на этом устройстве',
      },
      verify_page: {
        title: 'Подтвердите вашу личность',
        subtitle: 'Пожалуйста, подтвердите себя, используя один из ваших методов 2FA',
        choose_method: 'Выберите метод верификации',
      },
    },
    verify_email: {
      title: 'Подтвердите ваш адрес email',
      subtitle: 'Завершите процесс верификации, чтобы разблокировать все функции.',
      instructions: 'Мы отправили ссылку для верификации на ваш email. Нажмите на ссылку в сообщении, чтобы подтвердить учётную запись.',
      resend_label: 'Не получили письмо? Отправить ссылку для верификации повторно.',
      resend_helper: 'Мы отправим новое письмо для верификации на этот адрес.',
      resend_button: 'Отправить письмо для верификации повторно',
      back_to_login: 'Вернуться к входу',
      go_to_app: 'Перейти к панели управления',
      email_required: 'Адрес email требуется для повторной отправки ссылки.',
      invalid_or_expired: 'Ссылка для верификации неверна или истекла. Запросите новую ниже.',
      success: 'Адрес email успешно подтверждён.',
      redirecting_to_dashboard: 'Перенаправление на панель управления...',
      redirecting_to_login: 'Перенаправление на вход...',
    },
    pages: {
      login: 'Вход',
      register: 'Регистрация',
      verifyEmail: 'Подтверждение email',
      acceptInvite: 'Принятие приглашения',
      oauthCallback: 'OAuth Callback',
    },
    oauth: {
      button: {
        continue_with_google: 'Google',
        continue_with_facebook: 'Facebook',
        continue_with_github: 'GitHub',
        redirecting: 'Перенаправление...',
      },
      or_continue_with: 'Или продолжить с',
      callback: {
        signing_in: 'Вход...',
        processing: 'Обработка вашей {provider} аутентификации. Пожалуйста, подождите...',
        authentication_failed: 'Аутентификация не удалась',
        cancelled_or_denied: 'OAuth аутентификация была отменена или отклонена',
        invalid_parameters: 'Неверные параметры OAuth',
        invalid_state: 'Неверный параметр state — возможная CSRF атака',
        failed: 'OAuth аутентификация не удалась',
        success: 'Успешный вход через {provider}',
        two_factor_required: 'Требуется двухфакторная аутентификация',
        not_configured: 'Google OAuth не настроен',
        failed_to_initiate: 'Не удалось инициировать вход',
      },
    },
  },
}
